import axios from 'axios';
import authHeader from "@/service/AuthHeader";
import getEnvironment from "@/service/Environment";

const API_URL = getEnvironment().API_LOGGED_IN_URL + 'document';

export default class DocumentService {
    list(userId) {
        return axios.get(API_URL + `/list/${userId}`, { headers: authHeader() });
    }

    upload(userId, data) {
        const header = Object.assign({'Content-Type': 'application/json'}, authHeader());
        return axios.post(API_URL + `/upload/${userId}`, data, { headers: header });
    }

    delete(id) {
        return axios.delete(API_URL + `/delete/${id}`, { headers: authHeader() });
    }

    getDownloadUrl(id) {
        return API_URL + `/download/${id}`;
    }
}

